<template>
  <v-row>
    <v-col>
      <v-data-table
        :headers="headers"
        :items="documents"
        group-by="fileType"
        group-desc
        hide-default-footer
        disable-pagination
      >
        <template v-slot:group.header="{ group }">
          <td
            :colspan="headers.length"
            class="text-start grey--text subtitle-1 font-weight-medium"
          >{{ group.toString() === 'null'
            ? $lang.translate('documents.titles.others')
            : group.toString() }}</td>
        </template>
        <template v-slot:item.fileName="{ item }">
          <div class="d-flex align-center">
            <v-icon size="20" class="mr-4">mdi-file</v-icon>
            <div class="d-inline-block">
              <h3 class="subtitle-2">{{ _.get(item, 'fileName') }}</h3>
              <span class="caption grey--text">{{ _.get(item, 'uploadDate') | datetime }}</span>
            </div>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            @click="download(item)"
            :disabled="isDownloading(item)"
            :loading="isDownloading(item)"
            icon
          >
            <v-icon>mdi-cloud-download-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import { get } from 'lodash';
import { oftype } from '@/utils';
import { Mpo, Zenith } from '@/api';
import { download } from '@/helpers';

export default {
  name: 'app-business-scope-documents',
  data() {
    return {
      downloading: false,
      headers: [
        {
          text: this.$lang.translate('documents.titles.name'),
          sortable: false,
          value: 'fileName',
        },
        {
          text: this.$lang.translate('documents.titles.download'),
          sortable: false,
          value: 'action',
          width: '10%',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      scope: 'Scope',
      result: 'Order',
    }),
    documents() {
      const { documents } = this.result;
      if (documents) return oftype(documents, 'Array') ? documents : [documents];
      return [];
    },
  },
  methods: {
    async download(document) {
      try {
        if (this.scope.system === 'Zenith') {
          this.downloading = true;
          const { data } = await Zenith.downloadDocument({
            documentId: document.system,
            fileName: document.fileName,
          });

          download(window.URL.createObjectURL(data), get(document, 'fileName'));
          this.downloading = false;
        }

        if (this.scope.system === 'Mpo') {
          this.downloading = get(document, 'system');
          const file = await Mpo.downloadDocument({
            shipmentOrder: this.$route.params.number,
            document: this.downloading,
          });

          download(`data:octet-stream;base64,${file.data}`, get(document, 'fileName'));
          this.downloading = false;
        }
      } catch (e) {
        console.error('[Error]', e);
      }
    },
    isDownloading(document) {
      return get(document, 'system') === this.downloading;
    },
  },
};
</script>
